import { ACTION_TYPES } from "./actions";
import { calculateSaleSummary } from "./helpers";
export const AppReducer = (state, action) => {
    switch (action.type) {
        case ACTION_TYPES.CHANGE_PAGE:
            return { ...state, page: action.payload };
        case ACTION_TYPES.SET_SALE_DATA: {
            const rawSaleLines = action.payload?.saleLines || [];
            const summary = calculateSaleSummary(rawSaleLines);
            return {
                ...state,
                saleData: {
                    ...action.payload,
                    saleLines: summary.formattedSaleLines,
                    subtotal: summary.subtotal,
                    discount: summary.discount,
                    tax: summary.tax,
                    total: summary.total,
                },
            };
        }
        case ACTION_TYPES.SET_LOGIN_CONFIG:
            return {
                ...state,
                loginConfig: action.payload,
            };
        case ACTION_TYPES.SET_LANGUAGE:
            return {
                ...state,
                language: action.payload,
            };
        default:
            return state;
    }
};
